import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-6">
      <div className="max-w-7xl mx-auto px-4 flex flex-col items-center space-y-4 text-center">
        <nav className="flex flex-wrap justify-center gap-4 text-sm">
          <Link to="/about" className="text-gray-600 hover:text-gray-900">
            About
          </Link>
          <Link to="/buying" className="text-gray-600 hover:text-gray-900">
            Buying
          </Link>
          <Link to="/selling" className="text-gray-600 hover:text-gray-900">
            Selling
          </Link>
          <Link to="/areas" className="text-gray-600 hover:text-gray-900">
            Areas
          </Link>
          <Link to="/resources" className="text-gray-600 hover:text-gray-900">
            Resources
          </Link>
          <Link to="/testimonials" className="text-gray-600 hover:text-gray-900">
            Testimonials
          </Link>
          <Link to="/giveaway" className="text-gray-600 hover:text-gray-900">
            Giveaway
          </Link>
          <Link to="/contact" className="text-gray-600 hover:text-gray-900">
            Contact
          </Link>
        </nav>
        <p className="text-xs text-gray-500">
          © {new Date().getFullYear()} Move With Kendrick. All rights reserved.
        </p>
        <p className="text-xs text-gray-400">
          Powered by{' '}
          <a
            href="https://www.kalamazoowebsitedesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600 underline underline-offset-2 transition-colors"
          >
            Kalamazoo Website Design
          </a>
        </p>
      </div>
    </footer>
  );
}